{
  "WALLBOARD": {
    "LOADING": "Duke ngarkuar radhët telefonike...",
    "NO_QUEUES": "Nuk u gjetën radhë telefonike.",
    "NO_AGENTS": "Nuk ka agjentë në linjë në këtë radhë.",
    "UNKNOWN_CALLER": "Telefonues i panjohur",
    "STATUS": "Statusi",
    "TIME": "Koha",
    "AGENT": "Agjenti",
    "EXTENSION": "Shtesa",
    "READY": "Agjentë gati",
    "ON_CALL": "Agjentë në thirrje",
    "PAUSED": "Agjentë në pushim",
    "WAITING": "Thirrje në pritje",
    "MISSED_CALLS": "Thirrje të humbura",
    "HANDLED_CALLS": "Thirrje hyrëse të trajtuara",
    "OUTBOUND_CALLS": "Thirrje dalëse të trajtuara",
    "AVAILABILITY": "Disponueshmëria",
    "AVAILABILITY_TOOLTIP": "Përqindja e thirrjeve hyrëse të marra nga agjentët (thirrjet që u përgjigjën)",
    "AGENTS_COUNT": "({onCall} në thirrje / {total} gjithsej)",
    "NO_AVAILABLE": "(askush në linjë)",
    "WAITING_CALLERS_COUNT": "{count} në pritje",
    "CALLER": "Telefonuesi",
    "NUMBER": "Numri",
    "WAIT_TIME": "Koha e pritjes",
    "ACTION": "Veprimi",
    "PICKUP_CALL": "Përgjigju",
    "PICKUP_SUCCESS": "Kërkesa për marrjen e thirrjes u dërgua me sukses.",
    "PICKUP_ERROR": "Marrja e thirrjes dështoi. Provoni përsëri.",
    "PICKUP_DISABLED_TOOLTIP": "Nuk mund të merrni një thirrje ndërkohë që jeni në një thirrje ose jashtë linje.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Pa qasje"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Pa qasje"
    }
  }
}
